export const styles = {
  "listbox-container": ({ margin }) =>
    ["relative", margin ? margin : ""].join(" "),
  "listbox-button": ({ roundedTop, roundedBottom }) =>
    [
      "w-full",
      "pl-3",
      "pr-10",
      "py-2",
      "border-b",
      "border-gray-300",
      "relative",
      "bg-white",
      "text-left",
      "cursor-default",
      "focus:outline-none",
      "focus:ring-1",
      "focus:ring-yellow-me",
      "focus:border-yellow-me",
      "sm:text-sm",
      roundedTop ? roundedTop : "",
      roundedBottom ? roundedBottom : "",
    ].join(" "),
  "listbox-button-container-left": ["flex", "items-center"].join(" "),
  "listbox-button-dot": [
    "flex-shrink-0",
    "h-3",
    "w-3",
    "rounded-full",
    "bg-black",
  ].join(" "),
  "listbox-button-name": ["ml-3", "block", "truncate"].join(" "),
  "listbox-button-container-right": [
    "ml-3",
    "absolute",
    "inset-y-0",
    "right-0",
    "flex",
    "items-center",
    "pr-2",
    "pointer-events-none",
    "divide-x-2",
  ].join(" "),
  "listbox-button-close": ["h-5", "w-5", "text-gray-400", "mr-1"].join(" "),
  "listbox-button-arrow": ["h-8", "w-8", "text-gray-400"].join(" "),
  "transition-leave": ["transition", "ease-in", "duration-100"].join(" "),
  "transition-leave-form": ["opacity-100"].join(" "),
  "transition-leave-to": ["opacity-0"].join(" "),
  "listbox-options": [
    "absolute",
    "z-10",
    "mt-1",
    "w-full",
    "bg-white",
    "shadow-lg",
    "max-h-56",
    "rounded-md",
    "py-1",
    "text-base",
    "ring-1",
    "ring-black",
    "ring-opacity-5",
    "overflow-auto",
    "focus:outline-none",
    "sm:text-sm",
  ].join(" "),
  "listbox-option": ({ active }) =>
    [
      "py-2",
      "pl-3",
      "pr-9",
      "relative",
      "cursor-default",
      "select-none",
      active ? "text-white bg-yellow-me" : "text-gray-900",
    ].join(" "),
  "listbox-option-container": ["flex", "items-center"].join(" "),
  "listbox-option-icon": ["h-6", "w-6", "text-gray-400"].join(" "),
  "listbox-option-name": ({ selected }) =>
    [
      "ml-3",
      "block",
      "truncate",
      selected ? "font-semibold" : "font-normal",
    ].join(" "),
  "listbox-option-selected": ({ active }) =>
    [
      "absolute",
      "inset-y-0",
      "right-0",
      "flex",
      "items-center",
      "pr-4",
      active ? "text-white" : "text-yellow-me",
    ].join(" "),
  "listbox-option-selected-icon": ["w-5", "h-5"].join(" "),
};
